import React, { useEffect, useState } from 'react';
import accreditationPrintingService from '../../../services/accreditationPrintingService';
import TemplateList from './accredPrinting/TemplateList';
import TemplateDesigner from './accredPrinting/TemplateDesigner';
import BulkCardDownload from './BulkCardDownload';

// Cards are made one of two ways, per user type:
//  - Custom template: upload a PDF/image, then place the user's data (name, photo, zones, QR...) on it.
//  - Standard card: no template needed; drawn from views/accredCard/hbs/frontCard.hbs.
// Bulk Download builds the cards of everyone Sent For Printing, using each type's design.
// Tabs: 'list' | 'editor' | 'bulk'
const AccredPrinting = () => {
  const [activeTab, setActiveTab] = useState('list');
  const [editing, setEditing] = useState(null); // template row being edited, null = new
  const [listKey, setListKey] = useState(0); // bump to make the list refetch
  const [parentTypes, setParentTypes] = useState([]);
  const [userTypes, setUserTypes] = useState([]);

  useEffect(() => {
    Promise.all([
      accreditationPrintingService.getParentTypes(),
      accreditationPrintingService.getUserSubTypes(),
    ]).then(([parents, users]) => {
      setParentTypes(Array.isArray(parents) ? parents : []);
      setUserTypes(Array.isArray(users) ? users : []);
    });
  }, []);

  const openEditor = (item = null) => {
    setEditing(item);
    setActiveTab('editor');
  };

  const backToList = () => {
    setListKey((k) => k + 1);
    setActiveTab('list');
  };

  return (
    <div className="container-fluid py-3">
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 pb-2 border-bottom">
        <div>
          <h3 className="fw-bold mb-1 text-primary">
            <i className="fa fa-print me-2" />
            Accreditation Card Printing
          </h3>
          <p className="text-muted small mb-0">
            Upload a PDF or image template and place the user data on it, or use the standard card. Saving a template generates cards for everyone Sent For Printing; bulk-download them as a ZIP.
          </p>
        </div>
        {activeTab !== 'editor' && (
          <div className="d-flex gap-2 mt-2 mt-md-0">
            <button
              className={`btn btn-sm ${activeTab === 'bulk' ? 'btn-secondary' : 'btn-outline-secondary'}`}
              onClick={() => setActiveTab(activeTab === 'bulk' ? 'list' : 'bulk')}
            >
              <i className="fa fa-download me-1" /> {activeTab === 'bulk' ? 'Templates' : 'Bulk Download'}
            </button>
            <button className="btn btn-primary btn-sm px-3" onClick={() => openEditor(null)}>
              <i className="fa fa-plus me-1" /> Create New Template
            </button>
          </div>
        )}
      </div>

      {activeTab === 'list' && <TemplateList key={listKey} onNew={() => openEditor(null)} onEdit={openEditor} />}
      {activeTab === 'editor' && (
        <TemplateDesigner
          initial={editing}
          parentTypes={parentTypes}
          userTypes={userTypes}
          onBack={backToList}
          onSaved={() => setListKey((k) => k + 1)}
        />
      )}
      {activeTab === 'bulk' && <BulkCardDownload parentTypes={parentTypes} userTypes={userTypes} />}
    </div>
  );
};

export default AccredPrinting;
